module.exports = __webpack_public_path__ + "img/taad.c6a69796.svg";